import { useEffect, useState } from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { EmptyState } from "../../components/EmptyState";
import { api, type TrendSeries } from "../../lib/api";

export default function TrendsBody() {
  const [data, setData] = useState<TrendSeries | null | "error">(null);

  useEffect(() => {
    api.trends
      .body(90)
      .then(setData)
      .catch(() => setData("error"));
  }, []);

  const points = data && data !== "error" ? data.points : [];
  const hasData = points.some((p) => p.value !== null);
  const hasMuscle = points.some(
    (p) => p.value2 !== null && p.value2 !== undefined,
  );

  return (
    <div>
      <h2 className="section-title mb-4">Body composition</h2>

      {data === null ? (
        <p className="muted">Loading...</p>
      ) : !hasData ? (
        <EmptyState error={data === "error"} title="No body-composition history yet">
          The Withings scale records body fat, muscle and water alongside
          weight.
        </EmptyState>
      ) : (
        <div className="card card-pad">
          <ResponsiveContainer width="100%" height={280}>
            <LineChart data={points}>
              <CartesianGrid
                strokeDasharray="3 3"
                stroke="#e7e5e4"
                vertical={false}
              />
              <XAxis
                dataKey="date"
                axisLine={false}
                tickLine={false}
                fontSize={11}
              />
              <YAxis axisLine={false} tickLine={false} width={36} />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="value"
                name="Body fat %"
                stroke="#9a3412"
                strokeWidth={2}
                dot={false}
              />
              {hasMuscle && (
                <Line
                  type="monotone"
                  dataKey="value2"
                  name="Muscle mass"
                  stroke="#5e7a73"
                  strokeWidth={2}
                  dot={false}
                />
              )}
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
